import { createSlice } from '@reduxjs/toolkit'

export const mobileDisplay = createSlice({
  name: 'mobileDisplay',
  initialState: {
    displayResults: false,
    displaySideNav: true,
    displayFilters: false
  },
  reducers: {
    toggleDisplayResults: (state, action) => {
        state.displayResults = action.payload
    },
    toggleDisplaySideNav: (state, action) => {
        state.displaySideNav = action.payload
    },
    toggleDisplayFilters: (state, action) => {
      state.displayFilters = action.payload
  },
  },
})

export const { toggleDisplayResults, toggleDisplaySideNav, toggleDisplayFilters } = mobileDisplay.actions

export default mobileDisplay.reducer